import headerCarousel from './headerCarousel';
import allWidget from './allWidget';

/**
 * 自定义的扩展
 */
export default function newExtensions() {
  headerCarousel();
  allWidget();
}
